import React, { useState } from 'react';
import { Button, Input, Popover, Space, Typography } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { normalizeLinkUrl } from './checklistDescription';

const DescriptionLinkButton = ({ editor }) => {
	const [open, setOpen] = useState(false);
	const [url, setUrl] = useState('');
	const href = normalizeLinkUrl(url);
	const invalid = url.trim() !== '' && !href;

	const apply = () => {
		if (invalid) return;
		const chain = editor
			.chain()
			.focus()
			.extendMarkRange('link');
		(href ? chain.setLink({ href }) : chain.unsetLink()).run();
		setOpen(false);
	};

	const handleOpenChange = next => {
		if (next) setUrl(editor.getAttributes('link').href ?? '');
		setOpen(next);
	};

	return (
		<Popover
			trigger="click"
			open={open}
			onOpenChange={handleOpenChange}
			content={
				<Space direction="vertical" size={4}>
					<Space>
						<Input
							size="small"
							placeholder="https://"
							status={invalid ? 'error' : undefined}
							value={url}
							onChange={e => setUrl(e.target.value)}
							onPressEnter={apply}
						/>
						<Button size="small" type="primary" disabled={invalid} onClick={apply}>
							Apply
						</Button>
					</Space>
					{invalid && (
						<Typography.Text type="danger">Use a web address or email link</Typography.Text>
					)}
				</Space>
			}
		>
			<Button type="text" size="small" icon={<LinkOutlined />} aria-label="Link" />
		</Popover>
	);
};

export default DescriptionLinkButton;
